import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import api from './../../../services/axios'
import Loading from './../../../compoments/Loading';
import NavBack from './../../NavBack';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: '#F2F2F2',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

export default function Tma() {

  const [open, setOpen] = React.useState(false);
  const titleHeader = 'voltar'
  const classes = useStyles();

  const dateToString = (date, time, format = false) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let timeString = '';
    if (time) {
      timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    }
    if (!format) {
      return yyyy + '-' + mm + '-' + dd + '' + timeString;
    }
    return dd + '/' + mm + '/' + yyyy + ' ' + timeString;
  }

  const addDays = function (date, daysToAdd) {
    var _24HoursInMilliseconds = 86400000;
    return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
  }

  const loadData = async (start, end) => {
    setLoading(true)
    const { data } = await api.get('v1/graficos/tma?start=' + dateToString(start, true) + '&end=' + dateToString(end, true))
    setLoading(false)
    setDa(data)
  }

  useEffect(() => {
    
    loadData(start, end)
    setInterval(() => {
      loadData(start, end)
    }, 10000)
  }, [])

  const [da, setDa] = React.useState([]);
  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    return addDays(dt, -30); // padrão de dias atrás
  });
  const [end, setEnd] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });
  const [loading, setLoading] = React.useState(true);
  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <NavBack
          titleHeader={titleHeader}
        />
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} >
          <Container maxWidth="lg" className={classes.container}>
            <div style={{ padding: '20px 40px' }}>
              {loading ? <Loading /> :
                (<>
                  <div className='header' style={{ paddingTop: 20 }}>
                    <h1 className='title'>Gráfico TMA</h1>
                    <h4>De {dateToString(start, true, true)} até {dateToString(end, true, true)}</h4>
                  </div>
                  <Line data={da} 
                    options={options} /></>)
              }
            </div>
          </Container>
        </div>
      </main>
    </>
  )
}